import React, { useState, useEffect } from "react";
import "./FloatingAds.css";

const FloatingAds = () => {
  const [leftAds, setLeftAds] = useState([]);
  const [rightAds, setRightAds] = useState([]);
  const [currentLeftIndex, setCurrentLeftIndex] = useState(0);
  const [currentRightIndex, setCurrentRightIndex] = useState(0);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || (window.location.hostname !== "localhost" ? "/api" : "http://localhost:5000/api")}/ads`)
      .then((res) => res.json())
      .then((data) => {
        const clean = (url) => typeof url === "string" ? url.replace("http://localhost:5000", "") : url;
        setLeftAds((data.left_ads || []).map(clean));
        setRightAds((data.right_ads || []).map(clean));
      })
      .catch((err) => console.error("Error fetching ads:", err));
  }, []);

  // Auto-rotate left ads every 4.5 seconds
  useEffect(() => {
    if (leftAds.length > 1) {
      const interval = setInterval(() => {
        setCurrentLeftIndex((prev) => (prev + 1) % leftAds.length);
      }, 4500);
      return () => clearInterval(interval);
    }
  }, [leftAds.length]);

  // Auto-rotate right ads every 5 seconds
  useEffect(() => {
    if (rightAds.length > 1) {
      const interval = setInterval(() => {
        setCurrentRightIndex((prev) => (prev + 1) % rightAds.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [rightAds.length]);

  const leftAd = leftAds[currentLeftIndex];
  const rightAd = rightAds[currentRightIndex];

  return (
    <div className="floating-ads-container">
      {leftAd && (
        <div className="floating-ad left-ad">
          <img src={`${process.env.REACT_APP_BACKEND_URL || (window.location.hostname !== "localhost" ? "" : "http://localhost:5000")}${leftAd}`} alt="Advertisement Left" />
        </div>
      )}
      {rightAd && (
        <div className="floating-ad right-ad">
          <img src={`${process.env.REACT_APP_BACKEND_URL || (window.location.hostname !== "localhost" ? "" : "http://localhost:5000")}${rightAd}`} alt="Advertisement Right" />
        </div>
      )}
    </div>
  );
};

export default FloatingAds;
